module.exports = __webpack_public_path__ + "static/media/TJ-aquisition.862883f3.jpg";